
import { Game } from "@/models/Game";
import { LeaderBoard } from "@/models/LeaderBoard";
import { DateTime } from "luxon";
import { Component, Vue } from "vue-property-decorator";
import Overview from "../components/Overview.vue";
import GameStats from "../components/GameStats.vue";
import Leaderboard from "../components/Base/LeaderboardTable.vue";
import ProgressDialog from "../components/Base/ProgressDialog.vue";
import { LeaderBoardTeams } from "@/models/LeaderBoardTeams";

@Component({
  components: {
    Overview,
    ProgressDialog,
    GameStats,
    Leaderboard,
  },
})
class Dashboard extends Vue {
  startDate = DateTime.now()
    .plus({ days: -10 })
    .toString();
  endDate = DateTime.now().toString();
  endTime = "23:59";
  startTime = "00:00";
  showOverview = false;
  leaderBoardArray: LeaderBoard[] = [];
  gameList: Game[] = [];
  leaderBoardData = {} as LeaderBoardTeams;
  leaderBoardTitle = "";
  periodDay = 10;

  get getStartDateInShortFormat(): string {
    return (
      DateTime.fromISO(this.startDate.toString()).toFormat("dd/MM/yyyy") +
      " @ " +
      this.startTime
    );
  }
  get getEndDateInShortFormat(): string {
    return (
      DateTime.fromISO(this.endDate.toString()).toFormat("dd/MM/yyyy") +
      " @ " +
      this.endTime
    );
  }

  get getMin(): string {
    return this.startDate;
  }

  get getMax(): string {
    var date = DateTime.fromISO(this.startDate);
    return date.plus({ days: this.periodDay }).toString();
  }

  changeStartDate(): void {
    var date = DateTime.fromISO(this.endDate);
    var start = DateTime.fromISO(this.startDate);
    const diff = date.diff(start, "days");
    if (diff.days > this.periodDay)
      this.endDate = start.plus({ days: this.periodDay }).toString();
    if (diff.days < 0)
      this.endDate = start.plus({ days: this.periodDay }).toString();
  }

  getUTCTime(date: string, time: string): string {
    var time2 = DateTime.fromISO(time);

    return DateTime.fromISO(date.toString())
      .set({
        hour: time2.hour,
        minute: time2.minute,
        second: 0,
        millisecond: 0,
      })
      .toISO();
  }

  created(): void {
    this.$store.commit("authenication/setNavTab", 0);
  }

  search(): void {
    this.$bvModal.show("team-modal-spinner");
    var dates = {
      startDate: this.getUTCTime(this.startDate, this.startTime),
      endDate: this.getUTCTime(this.endDate, this.endTime),
    };
    this.$store
      .dispatch("leaderBoardStore/getAllLeaderBoardForGames", dates)
      .then((results) => {
        this.leaderBoardArray = results;
        this.showOverview = true;

        this.$bvModal.hide("team-modal-spinner");
      })
      .catch((error) => {
        console.log(error);
        this.$bvModal.hide("team-modal-spinner");
      });
  }
  openLeaderBoard(value: any): void {
    this.leaderBoardData = value.leaderBoard;
    this.leaderBoardTitle = value.leaderBoardTitle;
  }
}

export default Dashboard;
